const ZoneBiFilters = ({ filters, setFilters }) => {

    const handleChange = (e) => {
        setFilters((oldFilters) => {
            return {
                ...oldFilters,
                [e.target.name]: e.target.value,
                page: 1
            }
        });
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-4 p-3">
                    <div className="form-group">
                        <div className="card p-3">
                            <label className="form-label">Buscar por Nombre o ID</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Escriba para buscar..."
                                value={filters?.search || ''}
                                onChange={handleChange}
                                name="search"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ZoneBiFilters;
